import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  inject,
  input,
  OnInit,
  PLATFORM_ID
} from '@angular/core';
import {StoryblokStylingService} from '@core/services/storyblok-styling.service';
import {isPlatformBrowser} from '@angular/common';
import {StoryblokDirective} from '@core/directives/storyblok.directive';
import {StoryblokBaseComponent} from '../storyblok-base.component';
import {VimeoService} from '@core/services/vimeo.service';

@Component({
  selector: 'app-storyblok-vimeo',
  templateUrl: './storyblok-vimeo.component.html',
  styleUrls: ['./storyblok-vimeo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StoryblokDirective]
})
export class StoryblokVimeoComponent extends StoryblokBaseComponent implements OnInit, AfterViewInit {
  private storyblokStylingService = inject(StoryblokStylingService);
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private vimeoService = inject(VimeoService);
  private platformId = inject(PLATFORM_ID);


  readonly vimeoId = input<string>();
  readonly url = input<string>();
  readonly loop = input<boolean>();
  readonly _editable = input<any>();
  readonly general_styling = input<any>();
  readonly format_ratio = input<string>();

  @HostBinding('class') class: any;

  ngOnInit(): void {
    this.class = this.storyblokStylingService.getClassList(this.general_styling(), undefined, {'col-': 12}, this.col());
  }

  ngAfterViewInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const vimeoId = this.vimeoId();
    const url = this.url();
    if (!vimeoId && !url) {
      return;
    }
    const element = this.vimeoService.getVimeoElement(vimeoId, this.loop(), url);
    this.elementRef.nativeElement.querySelector('.videoWrapper')?.appendChild(element);
  }
}
